import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'
import App from './containers/app'
import AppAdmin from './containers-admin/app'
import 'sanitize.css/sanitize.css'
import './index.css'

const target = document.querySelector('#root')

 
 
 var isAdmin = window.location.href.indexOf('admin') >= 0

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        {isAdmin ?  <AppAdmin/> :<App />}
      </div>
    </ConnectedRouter>
  </Provider>,
  target
)
